import React from "react";
import { useSelector } from "react-redux";
import HomeTile from "./HomeTile";
import { HOME_TILES } from "../constants/homeTiles";

function Home() {
  const { companyName, clientId, divisionNumber } = useSelector(
    (state) => state.auth
  );

  // Role/privilege filtering will be applied here later.
  const tiles = HOME_TILES;

  return (
    <div>
      <div className="container">
        <div className="group">
          <div className="nav2 span12">
            <div className="user">
              <em style={{ fontSize: "18px" }} className="fa fa-user"></em>{" "}
              {clientId} - {divisionNumber} | {companyName}
            </div>
            <div className="bread-crumb">
              <em style={{ fontSize: "18px" }} className="fa fa-home"></em> Home
            </div>
          </div>
        </div>
      </div>
      <div className="sub-header">
        <div className="container">
          <div className="span12"></div>
        </div>
      </div>
      <div className="container">
        <h2 className="text-center white">
          Welcome
          <br />
          Hibbert Order Management Entryway
        </h2>
        <div className="home-tiles">
          <ul className="group">
            {tiles.map((tile) => (
              <HomeTile key={tile.id} {...tile} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Home;
